import { Navigate, Outlet, useLocation } from "react-router";
import { Spinner } from "@astrum/ui";
import { useAuth } from "../lib/auth.js";
import { TwoFactorRequired } from "./TwoFactorRequired.js";

/**
 * Gates every authenticated route. Shown before `viewer` is known so a
 * signed-in user never sees a flash of the login screen on refresh.
 */
export function RequireAuth() {
  const { viewer, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          display: "grid",
          placeItems: "center",
          minHeight: "var(--app-h)",
        }}
      >
        <Spinner label="Checking your session" />
      </div>
    );
  }

  if (!viewer) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  /*
   * An account on an administrator-issued password can reach exactly one
   * screen until it has been replaced. Gating here rather than per-route means
   * a page added later cannot forget to check.
   */
  if (viewer.mustChangePassword && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  // The workspace requires two-factor and this person has none: nothing else
  // works until they enrol, so the setup screen replaces the app.
  if (viewer.twoFactorSetupRequired) return <TwoFactorRequired />;

  return <Outlet />;
}
